export default __webpack_public_path__ + "static/media/history_slide_3.64cbc53d.jpg";